import Vue from 'vue'
import AddressSelect from './AddressSelect.vue'

const AddressSelectConstructor = Vue.extend(AddressSelect)
const instance = new AddressSelectConstructor({
  el: document.createElement('div')
})

instance.vm = instance.$mount()
document.body.appendChild(instance.vm.$el)

Vue.prototype.$address = instance

export default instance



// WEBPACK FOOTER //
// ./src/components/AddressSelect/index.js